import React from "react";

// seo
import Helmet from "react-helmet";
// import { helmetJsonLdProp } from "react-schemaorg";

import Section from "../../components/shared-ui/Section/Section";

// @todo - change to PED versions
import PEDLayout from "./PEDLayout";
import PEDHeroHeader from "../../components/HeroHeader/PEDHeroHeader";

import "../../css/PED/Resources.scss";

export default function Resources() {
  return (
    <React.Fragment>
      <Helmet>
        <title>Pediatric ITP Resources for Parents & Caregivers| DOPTELET®️ and DOPTELET Sprinkle (avatrombopag)</title>
        <meta name="description" content="Find helpful resources to support your child with persistent or chronic ITP. Access downloadable guides, understand copay assistance and tips for doctor conversations." />
      </Helmet>
      <PEDLayout pageClass="ped-resources">
        <Section sectionClass="coming-soon-cta-banner">
          <div className="coming-soon-cta-card text-center">
            <div className="d-flex flex-column flex-lg-row">
              <div style={{ flex: "1 1 100%" }}>
                <h2>Coming soon!</h2>
                <p>
                  Doptelet Sprinkle: oral granules that must be sprinkled on a soft food or liquid.
                </p>
              </div>
            </div>
          </div>
        </Section>

        <PEDHeroHeader
          extraClass="large-hero inner-bg home-hero"
          markup={
            <>
              <h1>RESOURCES FOR YOUR FAMILY</h1>
              <p>
                Whether your family is looking for financial assistance, ITP
                organizations, or information on getting started, you’ve come to
                the right place for persistent or chronic ITP resources.
              </p>
            </>
          }
          maxWidth="525"
          bgImage={[
            "/images/ped/hero/resources-hero-desktop.png",
            "/images/ped/hero/resources-hero-desktop@2x.png",
          ]}
          bgImageMobile={[
            "/images/ped/hero/resources-hero.png",
            "/images/ped/hero/resources-hero@2x.png",
          ]}
        />

        <Section sectionClass="section-padding resource-list">
          <h2>What kind of support is your family looking for?</h2>
          <div className="d-flex flex-column flex-lg-row flex-wrap resource-list-wrapper">
            <div className="resource-list-card">
              <div className="d-flex flex-row align-items-center">
                <img src="/images/ped/icons/icon-financial@2x.png" alt="" />
                <h3>Financial Assistance</h3>
              </div>
              <p>
                See how programs like the Copay Assistance Program might help
                your family save on treatment.
              </p>
              <a
                href="/pediatric-itp/support-and-resources/caregiver-financial-assistance/"
                className="btn btn-primary w-100 btn-arrow"
              >
                <span>Learn More</span>
              </a>
            </div>
            <div className="resource-list-card">
              <div className="d-flex flex-row align-items-center">
                <img
                  src="/images/ped/icons/icon-patient-resources@2x.png"
                  alt=""
                />
                <h3>Patient Resources</h3>
              </div>
              <p>
                View helpful downloads, information about support organizations,
                and more.
              </p>
              <a
                href="/pediatric-itp/support-and-resources/itp-faqs/"
                className="btn btn-primary w-100 btn-arrow"
              >
                <span>Learn More</span>
              </a>
            </div>
            <div className="resource-list-card">
              <div className="d-flex flex-row align-items-center">
                <img
                  src="/images/ped/icons/icon-doptelet-updates@2x.png"
                  alt=""
                />
                <h3>Get Treatment Updates</h3>
              </div>
              <p>
                Sign up for tools and tips, and to stay connected with Doptelet
                and Doptelet Sprinkle.
              </p>
              <a
                href="/pediatric-itp/support-and-resources/caring-for-child-with-itp/"
                className="btn btn-primary w-100 btn-arrow"
              >
                <span>Learn More</span>
              </a>
            </div>
            <div className="resource-list-card">
              <div className="d-flex flex-row align-items-center">
                <img src="/images/ped/icons/icon-faqs@2x.png" alt="" />
                <h3>FAQs</h3>
              </div>
              <p>
                Get answers to the most commonly asked questions about ITP,
                Doptelet, and Doptelet Sprinkle.
              </p>
              <a
                href="/pediatric-itp/support-and-resources/itp-faqs/"
                className="btn btn-primary w-100 btn-arrow"
              >
                <span>Learn More</span>
              </a>
            </div>
          </div>
        </Section>
      </PEDLayout>
    </React.Fragment>
  );
}
